import React, { FunctionComponent, lazy, ReactElement, Suspense, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { Spinner } from 'reactstrap';
import NiceModal from '@ebay/nice-modal-react';
import CookiesModal from '../../components/Modal/CookiesModal';
import { accessibilityRoute } from '../../constants/ApiRoutes';
import { useStoreState } from '../../store/hooks';
import Accessibility from '../Accessibility';

/* PLOP_INJECT_LAZY_IMPORT */
const Home = React.lazy(() => import('../Home'));
const GettingStarted = React.lazy(() => import('../GettingStarted'));
const SiteServices = React.lazy(() => import('../SiteServices'));
const SmartBuildingPage = React.lazy(() => import('../SmartBuildingPage'));
const AvailableDesksPage = React.lazy(() => import('../AvailableDesksPage'));
const NotFound = lazy(() => import('../NotFound'));
const Maps = React.lazy(() => import('../Maps'));

const AppRoutes: FunctionComponent = (): ReactElement => {
  const [cookies, setCookie] = useCookies<CookiesKeys, CookieValues>([
    'selected_building',
    'selected_site',
    'selected_country',
  ]);
  const cookiesSeen = useStoreState((state) => state.cookies.cookiesSeen);
  const navigate = useNavigate();
  const location = useLocation();

  React.useEffect(() => {
    if (!cookiesSeen) {
      NiceModal.show(CookiesModal).then();
    }
  }, [cookiesSeen]);

  const jsxSwitchAllRoutes = (
    <>
      <Route path="/" />
      <Route path="/docs" element={<GettingStarted />} />
      <Route path="/services" element={<SiteServices cookies={cookies} />} />
      <Route path="/smartbuilding" element={<SmartBuildingPage setCookie={setCookie} cookies={cookies} />} />
      <Route path="/availabledesks" element={<AvailableDesksPage />} />
      <Route path="/maps" element={<Maps />} />
      <Route path="/mapsFromAvailableDesks" element={<Maps />} />
      <Route path={accessibilityRoute} element={<Accessibility />} />
      <Route path="*" element={<NotFound />} />
    </>
  );
  const jsxSwitchRestraintRoutes = (
    <Route>
      <Route index path="/" element={<Home />} />
      <Route path={accessibilityRoute} element={<Accessibility />} />
    </Route>
  );

  const site = useStoreState((state) => state.sites);

  useEffect(() => {
    if (location.pathname !== '/services') {
      navigate('/services');
    }
  }, []);

  return (
    <Suspense
      fallback={
        <div className="container-centered">
          <Spinner color="dark" style={{ width: '3rem', height: '3rem' }} />
        </div>
      }
    >
      <Routes>
        {site.selectedSite !== 'UNDEFINED' &&
        cookies['selected_building'] &&
        cookies['selected_site'] &&
        cookies['selected_country']
          ? jsxSwitchAllRoutes
          : jsxSwitchRestraintRoutes}
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
